import { render, staticRenderFns } from "./ClassTime.vue?vue&type=template&id=08ea6c12&lang=true"
import script from "./ClassTime.vue?vue&type=script&lang=js"
export * from "./ClassTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports